import React from 'react';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import { ToggleButton, ToggleButtonGroup, ButtonGroup, Button, Checkbox } from '@mui/material';
import CustomCalendarSVG from '../../../components/CustomCalendarSVG';
import { MdArrowBack, MdOutlineTextDecrease, MdOutlineTextIncrease, MdSimCardDownload } from "react-icons/md";

const SmartFilterPanel = (props) => {
    const {
        startDate,
        endDate,
        setStartDate,
        setEndDate,
        handleSearch,
        alignment,
        handleAlignment,
        fontsize,
        setFontsize,
        handleChange,
        handleExport,
        checked,
        showBackButton = false,
        handleBack,
        backLabel = 'Back',
    } = props;

    const fontSizeOptions = [
        { label: 'Small', value: 'text-xs', icon: MdOutlineTextDecrease },
        { label: 'Medium', value: 'text-sm', icon: null },
        { label: 'Large', value: 'text-base', icon: MdOutlineTextIncrease },
    ];

    return (
        <div className='bg-slate-100 dark:bg-custom_dark_primary2 rounded-sm p-2 mb-2 flex gap-2 flex-wrap ring-1 ring-slate-300 dark:ring-slate-500'>
            <div className='flex flex-col bg-slate-50 p-1 px-2 rounded-sm shadow-md dark:bg-custom_dark_background'>
                <p className='text-xs mb-1 font-semibold dark:text-customWhite'>Searchable date</p>
                <div className='flex gap-2 flex-wrap items-center'>
                    <div className={`flex w-40 h-9 text-sm justify-center rounded-sm bg-customTitleColor dark:bg-custom_dark_primary2 mb-1 relative dark:text-customWhite dark:border-custom_dark_primary`}>
                        <input
                            className="bg-customTitleColor dark:bg-custom_dark_primary2 text-sm font-semibold text-gray-700 px-3 rounded-md border border-gray-200 shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-gray-100 transition duration-300 ease-in-out w-full cursor-pointer dark:text-customWhite dark:border-custom_dark_primary"
                            type="date"
                            value={startDate}
                            onChange={e => setStartDate(e.target.value)}
                        />
                        <CustomCalendarSVG />
                    </div>
                    <div className={`flex w-40 h-9 text-sm justify-center rounded-sm bg-customTitleColor mb-1 relative dark:bg-custom_dark_primary2 dark:text-customWhite dark:border-custom_dark_primary`}>
                        <input
                            className="bg-customTitleColor dark:bg-custom_dark_primary2 dark:text-customWhite dark:border-custom_dark_primary text-sm font-semibold text-gray-700 px-3 rounded-md border border-gray-200 shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-gray-100 transition duration-300 ease-in-out w-full cursor-pointer"
                            type="date"
                            value={endDate}
                            onChange={e => setEndDate(e.target.value)}
                        />
                        <CustomCalendarSVG />
                    </div>
                    <button
                        type='button'
                        className='text-white px-5 py-1 my-2 hover:bg-customAccentBlue/90 rounded-sm bg-customAccentBlue dark:bg-customAccent dark:hover:bg-customAccent/90 dark:text-customFontMilkWhite'
                        onClick={() => handleSearch()}
                    >
                        <span className='text-sm'>Search</span>
                    </button>
                </div>
            </div>
            <div className='flex flex-col bg-slate-50 p-1 px-2 rounded-sm shadow-md dark:bg-custom_dark_background'>
                <p className='text-xs mb-1 font-semibold dark:text-customWhite'>Alignment</p>
                <ToggleButtonGroup
                    value={alignment}
                    exclusive
                    size="small"
                    onChange={handleAlignment}
                    className='bg-white'
                    aria-label="text alignment"
                >
                    <ToggleButton value="left" aria-label="left aligned">
                        <FormatAlignLeftIcon className="text-sm" />
                    </ToggleButton>
                    <ToggleButton value="center" aria-label="centered">
                        <FormatAlignCenterIcon />
                    </ToggleButton>
                    <ToggleButton value="right" aria-label="right aligned">
                        <FormatAlignRightIcon />
                    </ToggleButton>
                </ToggleButtonGroup>
            </div>
            <div className='flex flex-col bg-slate-50 p-1 px-2 rounded-sm shadow-md dark:bg-custom_dark_background'>
                <p className='text-xs mb-1 font-medium dark:text-customWhite'>Font Size</p>
                <ToggleButtonGroup
                    value={fontsize}
                    exclusive
                    size="small"
                    onChange={(_, nextFontsize) => {
                        if (nextFontsize) {
                            setFontsize(nextFontsize);
                        }
                    }}
                    aria-label="font size"
                    className='bg-white dark:bg-custom_dark_primary2'
                    sx={{
                        '& .MuiToggleButton-root': {
                            minWidth: 42,
                            gap: '4px',
                            paddingInline: '8px',
                            color: '#292E4C',
                            borderColor: '#D1DAE4',
                            textTransform: 'none',
                        },
                        '.dark & .MuiToggleButton-root': {
                            color: '#fff',
                        },
                        '& .Mui-selected, & .Mui-selected:hover': {
                            backgroundColor: '#292E4C',
                            color: '#fff',
                        },
                    }}
                >
                    {fontSizeOptions.map(({ label, value, icon: Icon }) => (
                        <ToggleButton
                            key={value}
                            value={value}
                            aria-label={`${label} font size`}
                            title={label}
                        >
                            {Icon ? <Icon className="text-base" /> : <span className="text-xs font-bold">Aa</span>}
                            <span className='text-xs'>{label}</span>
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
            </div>
            <div className='flex flex-col bg-slate-50 p-1 px-2 rounded-sm shadow-md dark:bg-custom_dark_background'>
                <p className='text-xs mb-1 font-semibold dark:text-customWhite'>Type Filterable</p>
                <div className='flex gap-1'>
                    <div className='flex items-center'>
                        <Checkbox
                            color='info'
                            checked={checked.single}
                            size='small'
                            onChange={(e) => handleChange(e, "single")}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                        <span className='text-sm dark:text-customWhite'>Single</span>
                    </div>
                    <div className='flex items-center'>
                        <Checkbox
                            checked={checked.mix}
                            color='info'
                            size='small'
                            onChange={(e) => handleChange(e, "mix")}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                        <span className='text-sm dark:text-customWhite'>Mix</span>
                    </div>
                    {/* <div className='flex items-center'>
                        <Checkbox
                            checked={checked.total}
                            color='info'
                            disabled
                            size='small'
                            onChange={(e) => handleChange(e, "total")}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                        <span className='text-sm dark:text-customWhite'>Total</span>
                    </div> */}
                </div>
            </div>
            <div className='flex flex-col bg-slate-50 p-1 px-2 rounded-sm shadow-md dark:bg-custom_dark_background'>
                <p className='text-xs mb-1 font-semibold dark:text-customWhite'>Export Data</p>
                <div className='flex gap-2'>
                    <ButtonGroup variant="contained" aria-label="Basic button group">
                        <Button
                            variant="contained"
                            size="small"
                            style={{ background: '#8A42B8' }}
                            onClick={() => handleExport('csv')}
                        >
                            <span className='text-xs flex gap-1 items-center'>Export CSV <MdSimCardDownload/></span>
                        </Button>
                        {/* <Button
                            variant="contained"
                            size="small"
                            style={{ background: '#0E93A9' }}
                            onClick={() => handleExport('xlsx')}
                        >
                            <span className='text-xs'>Export Excel</span>
                        </Button> */}
                    </ButtonGroup>
                </div>
            </div>
             {showBackButton ? (
                <div className='flex flex-col justify-center bg-slate-50 p-1 px-2 rounded-sm shadow-md dark:bg-custom_dark_background'>
                    <button
                        type='button'
                        className='text-white px-5 py-1 my-2 hover:bg-customSecondaryText/80 rounded-sm bg-customSecondaryText dark:bg-customSecondaryText dark:text-customFontMilkWhite'
                        onClick={handleBack}
                    >
                        <span className='text-sm flex items-center'><MdArrowBack /> {backLabel}</span>
                    </button>
                </div>
            ) : null}
        </div>
    )
}

export default SmartFilterPanel;
